"use client"

import React from 'react'
import { useMobileContext } from './MobileContext'
import { Card, Typography, Collapse, Space } from 'antd'
import { useTranslation } from 'react-i18next'
import { faqData } from './Data/FAQData'

const { Title, Text, Paragraph } = Typography

const FAQ: React.FC = () => {
  const isMobile = useMobileContext()
  const { t } = useTranslation()

  return (
    <Card className={!isMobile ? 'p-6' : 'p-2'}>
      <Title level={2}>{t(faqData.title)}</Title>

      <Paragraph className="mb-4">
        {t(faqData.description, { platform: process.env.NEXT_PUBLIC_PLATFORM_NAME })}
      </Paragraph>

      <Collapse
        accordion
        bordered={true}
        className="mb-6"
        items={faqData.questions.map((item, index) => ({
          key: index.toString(),
          label: t(item.question, { platform: process.env.NEXT_PUBLIC_PLATFORM_NAME }),
          children: (
            <Paragraph>{t(item.answer, { platform: process.env.NEXT_PUBLIC_PLATFORM_NAME })}</Paragraph>
          ),
        }))}
      />

      <div className="mt-6">
        <Title level={3}>{t("esim.faq_contact_title")}</Title>
        <Paragraph>
          {t("esim.faq_contact_desc")}
        </Paragraph>

        <Space orientation="vertical" className="mt-2">
          <Text strong>Hotline: </Text> <Text>{process.env.NEXT_PUBLIC_COMPANY_PHONE || ""} (8:00 - 22:00 {t("common.daily")})</Text>
          <Text strong>Email: </Text> <Text>esim@traveleasy.com.vn</Text>
          <Text strong>{t("esim.faq_contact_chat_online")}: </Text> <Text>{t("esim.faq_contact_note", { platform: process.env.NEXT_PUBLIC_PLATFORM_NAME })}</Text>
        </Space>
      </div>
    </Card>
  )
}

export default FAQ